import request from '../request';

export function getDealers(params) {
  return request({
    url: "directories/dealers",
    method: "get",
    params
  })
}

export function getDealersPage(id) {
  return request( {
    url: `directories/dealers?page=${id}`,
    method: "get"
  })
}

export function getIDDealers(id) {
  return request({
    url: `directories/dealers/${id}`,
    method: "get"
  })
}

export function postDealers(data) {
  return request({
    url: "directories/dealers",
    method: "post",
    data
  })
}

export function putDealers(data) {
  return request({
    url: `directories/dealers/${data.id}`,
    method: "put",
    data
  })
}

export function deleteDealers(id) {
  return request({
    url: `directories/dealers/${id}`,
    method: "delete",
    
  })
}